<template>
  <div class="shop-cart-shipping">
    <div class="shop-cart-shipping__name">
      {{ shippingMethod.name }}
    </div>
    <div class="shop-cart-shipping__fee">
      {{ formattedShippingCosts.value }}
      <div class="shop-cart-shipping__info">
        {{ formattedShippingCosts.additionalText }}
      </div>
    </div>
  </div>
</template>

<script setup>
const checkoutStore = useCheckoutStore();
const shippingMethod = computed(() => checkoutStore.getShippingMethod);

const formattedShippingCosts = computed(() => checkoutStore.getFormattedShippingCosts);
</script>

<style lang="scss" scoped>
.shop-cart-shipping {
    @include typo-font('regular');
    @include typo-size('label');
    display: flex;
    justify-content: space-between;
    padding-top: 2px;
    margin-bottom: 8px;
    color: $C_GREEN_DARK;
}

.shop-cart-shipping__info {
    display: block;
    font-size: clamp(15px, 14.6987951807px + 0.000753012 * var(--app-width), 16px);
}

.shop-cart-shipping__fee {
    text-align: right;
}
</style>
